const itemData = [
  {
    img: 'https://images.unsplash.com/photo-1492896864827-5fc3ef540db6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHBhcmFwZW50ZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
    title: 'montagne',
  },
  {
    img: 'https://images.unsplash.com/photo-1597182471537-7b7851fd0d58?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bW9udGFnbmV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60',
    title: 'montagne2',
  },
  {
    img: 'https://images.unsplash.com/photo-1592208127889-a44ea490c64b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8cGFyYXBlbnRlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60',
    title: 'montagne3',
  },
  {
    img: 'https://images.unsplash.com/photo-1499384048662-8f714ec1420d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8cGFyYXBlbnRlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60',
    title: 'montagne4',
  },

];
export default itemData;
